import React from 'react';
import { Brain, RefreshCw } from 'lucide-react';

export const AiDescribePhase: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-8">
      <div className="bg-white rounded-xl border border-slate-200 p-8">
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-2">
            <Brain className="w-6 h-6 text-purple-600" />
            <h2 className="text-2xl font-bold text-slate-900">AI Framework Generation</h2>
          </div>
          <p className="text-slate-500 text-sm">
            Generating compliance framework from your description...
          </p>
        </div>
        <div className="text-center py-10">
          <div className="flex justify-center mb-6">
            <RefreshCw className="text-blue-600 animate-spin" size={40} />
          </div>
          <p className="text-sm font-medium text-slate-700 mb-2">Analyzing your requirements...</p>
          <p className="text-xs text-slate-500">This may take a few moments</p>
        </div>
      </div>
    </div>
  );
};
